export default function objectIDToDate(objectID: string): Date {
    return new Date(
        parseInt(
            objectID.substring(0, 8),
            16,
        ) * 1000
    );
}
